import { atom } from 'jotai'
import { AddressValidationResult, LocationChange } from '../api/models'
import type { RequireOnly } from '../utils/utilityTypes'

/********** Address Scheduler Atoms **********/

// this will contain the location change object that is being edited
export type IncompleteLocationChange = RequireOnly<LocationChange, 'locationId'>
export type LocationChangeWithAddress = RequireOnly<LocationChange, 'locationId' | 'address'>
export const currentLocationChangeAtom = atom<IncompleteLocationChange>()

// this will track whether the user has started the provisioning workflow for a given location, keyed by locationId
export const provisioningWorkflowStartedByLocationAtom = atom<Record<string, boolean>>({})

// the ValidationResultsPage uses this to view validation results will contain the location change object that is being edited
export const addressValidationResultAtom = atom<AddressValidationResult>()
// this is the index of the address validation result the user chose
export type SelectedAddressValidationResultIndex = number | 'UNVERIFIED'
export const selectedAddressValidationResultIndexAtom = atom<SelectedAddressValidationResultIndex>()

/********** Dark Mode Toggle Atoms **********/

export const colorModeContainerAtom = atom<HTMLDivElement>()
